import React from 'react';

function LaneLine({ height, laneWidth, contentOffsetX }: any) {
    const lineStyle = { stroke: '#e5e7eb', strokeWidth: 1 }; 
    const LANE_COUNT = 5;

    return (
        <g className="lane-lines" transform={`translate(${contentOffsetX}, 0)`}>
            {Array.from({ length: LANE_COUNT }).map((_, i) => (
                <line 
                    key={i} 
                    x1={i * laneWidth} 
                    y1="0" 
                    x2={i * laneWidth} 
                    y2={height} 
                    style={lineStyle} 
                />
            ))}
            <line 
                x1={LANE_COUNT * laneWidth} 
                y1="0" 
                x2={LANE_COUNT * laneWidth} 
                y2={height} 
                style={lineStyle} 
            />
        </g>
    );
}

export default LaneLine;